import { ConnectionPointType } from "smart-filters";
import { InputDisplayManager } from "../graphSystem/display/inputDisplayManager.js";
import { WebCamInputBlockName } from "./editorBlocks/blockNames.js";
/**
 * Optional override of the InputDisplayManager to provide custom display for particular blocks if desired.
 */
export class CustomInputDisplayManager extends InputDisplayManager {
    /**
     * Returns preview content for custom input blocks, or null if no custom content is needed.
     * @param nodeData - The node data to display
     * @param contentArea - The content area to update
     * @returns
     */
    updatePreviewContent(nodeData, contentArea) {
        super.updatePreviewContent(nodeData, contentArea);
        let value;
        const inputBlock = nodeData.data;
        if (inputBlock.type === ConnectionPointType.Texture && inputBlock.name === WebCamInputBlockName) {
            const webCamInputBlock = inputBlock;
            value = webCamInputBlock.webcamSource?.label ?? "Default";
            contentArea.innerHTML = value;
        }
        else {
            return super.updatePreviewContent(nodeData, contentArea);
        }
    }
}
//# sourceMappingURL=customInputDisplayManager.js.map